export default __webpack_public_path__ + "static/media/640_portfolio02-it-web.e72580e7.png";